import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatExpansionModule } from '@angular/material/expansion';
import { debounceTime, switchMap } from 'rxjs';
import { ListarClientesBrokerRequest } from 'src/app/comision-broker/domain/request/Comisiones-Broker-Request';
import { ComisionesRepository } from 'src/app/comisiones/domain/Comisiones-repository';
import { ProformaRepository } from 'src/app/proforma/domain/proforma.repository';
import { puertoRequest, requestejecutivo } from 'src/app/proforma/domain/request/proforma_request';
import { listaejecutivos } from 'src/app/proforma/domain/response/proforma_response';
import { ReportesRepository } from 'src/app/repositorio/reportes.repository';
// import { ReportesRepository } from 'src/app/reporte-ventas/domain/reportes.repository';
// import { FiltrosMultiSelect, ReporteVentasIRequest } from 'src/app/reporte-ventas/domain/request/reporte-ventas-request';
import { DataExportExcel, UtilService } from 'src/app/services/util.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { FiltrosMultiSelect, ReporteVentasIRequest } from '../../domain/reporte-ventas.request';

@Component({
    selector: 'app-reporte-seguimiento',
    standalone:true,
    imports: [
        CommonModule,
        SharedModule,
        MatAutocompleteModule,
        MatExpansionModule
    ],
    templateUrl: './reporte-seguimiento.component.html',
    styleUrl: './reporte-seguimiento.component.css'
})
export class ReporteSeguimientoComponent {

  constructor(
    private readonly reportes: ReportesRepository,
    private readonly util: UtilService,
    private readonly proforma: ProformaRepository,
    private readonly comisiones: ComisionesRepository
  ) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.listarejecutivo()
    this.inicializarFormulario()
    this.GenerarReporteSeguimiento()
  }

  group: FormGroup
  // group2: FormGroup
  inicializarFormulario() {

    this.group = new FormGroup({
      desde: new FormControl(new Date(new Date().getFullYear(), new Date().getMonth(), 1), null),
      hasta: new FormControl(new Date(), null),
      ejecutivo: new FormControl(null, null),
      cliente: new FormControl([], null),
      pod: new FormControl([], null),
      pol: new FormControl([], null),
      etd: new FormControl([], null),
      bkg: new FormControl([], null),
      ov: new FormControl([], null),
      service: new FormControl([], null),
      nave: new FormControl([], null),
      ejecutivos: new FormControl([], null),
      linea: new FormControl([], null),
    })

    // this.group2 = new FormGroup({
    //   desde: new FormControl(new Date(new Date().getFullYear(), 0, 1), null),
    //   hasta: new FormControl(new Date(), null),
    //   ejecutivo: new FormControl([], null),
    //   pod: new FormControl([], null),
    //   pol: new FormControl([], null),
    //   cliente: new FormControl([], null),
    //   linea: new FormControl([], null),
    //   service: new FormControl([], null),
    //   etd: new FormControl(null, null),
    // })
  }

  toppingList: any[] = []

  selectAllIfAllSelected() {
    const selectedOptions = this.group.value.ejecutivos;
    if (selectedOptions.includes('')) {
      this.group.get('ejecutivos').setValue([...this.toppingList.map(t => t.codigo)]);
    }
  }

  getSelectedEjecutivosNames() {
    const selectedEjecutivos = this.group.value.ejecutivos;
    if (!selectedEjecutivos || selectedEjecutivos.length === 0) {
      return '';
    }

    const selectedNames = selectedEjecutivos.map(codigo => {
      const ejecutivo = this.toppingList.find(e => e.codigo === codigo);
      return ejecutivo ? ejecutivo.nombre : '';
    });

    return selectedNames.join(', ');
  }


  getTotalCost(columnName: string, arr: any): string {
    let total = 0
    if (arr != undefined) {
      const columnData = (arr.map(row => this.parseNumber(row[columnName] == null ? '0' : row[columnName].toString())));
      total = columnData.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    }

    if (columnName == 'porcentaje') {
      return (total).toFixed(0);
    } else {
      return total.toLocaleString('es-PE');
    }

  }

  parseNumber(numberString: string): number {
    let sanitizedString
    if (numberString != null) {
      const formattedString = numberString.replace(',', '&');
      sanitizedString = formattedString.replace('&', '');
    }
    return parseFloat(sanitizedString);
  }

  orderFieldName: string = ''
  statusFieldName: string = 'sort'
  countFieldName: number = 0
  sortColumn(fieldName: string) {
    if (fieldName == 'fecha' || fieldName == 'etd') {

      if (fieldName == this.orderFieldName && this.statusFieldName == 'arrow_downward') {
        this.dataReporteSeguimiento.sort((a, b) => {
          // Convertir las fechas al formato YYYY/MM/DD para comparación adecuada
          let dateA = new Date(a[fieldName].split('/').reverse().join('/'));
          let dateB = new Date(b[fieldName].split('/').reverse().join('/'));

          // Ordenar de más reciente a más antiguo (ascendente)
          if (dateA > dateB) return -1;
          if (dateA < dateB) return 1;
          return 0;
        });
        this.statusFieldName = 'arrow_upward';
      } else {
        this.dataReporteSeguimiento.sort((a, b) => {
          // Convertir las fechas al formato YYYY/MM/DD para comparación adecuada
          let dateA = new Date(a[fieldName].split('/').reverse().join('/'));
          let dateB = new Date(b[fieldName].split('/').reverse().join('/'));

          // Ordenar de más antiguo a más reciente (descendente)
          if (dateA < dateB) return -1;
          if (dateA > dateB) return 1;
          return 0;
        });
        this.statusFieldName = 'arrow_downward';
      }

    } else {

      if (fieldName == this.orderFieldName && this.statusFieldName == 'arrow_downward') {
        this.dataReporteSeguimiento.sort((a, b) => { if (a[fieldName] > (b[fieldName])) return -1; if (a[fieldName] < b[fieldName]) return 1; return 0 })
        this.statusFieldName = 'arrow_upward'
      } else {
        this.dataReporteSeguimiento.sort((a, b) => { if (a[fieldName] < (b[fieldName])) return -1; if (a[fieldName] > b[fieldName]) return 1; return 0 })
        this.statusFieldName = 'arrow_downward'
      }

    }

    this.orderFieldName = fieldName
  }

  onDateChange(event: any, campo: string, formulario: string) {
    const selectedDate = event.value;
    selectedDate.setHours(0, 0, 0, 0);

    if (formulario == 'group') {
      this.group.get(campo).setValue(selectedDate.toISOString());
    }
  }

  limpiar(value, form) {

    if (form == "group") {
      this.group.get(value).reset([])
      this.GroupCodigos[value] = 0

    }
  }

  GroupCodigos: any[] = [{ pod: 0, pol: 0, linea: 0, cliente: 0 }]

  GroupClientesFiltrados: any[] = [];
  GroupListaClientes: any[] = []
  GroupCargarClientes(): void {
    const request: ListarClientesBrokerRequest = {
      nombre: '',
      tipo: '001'
    };

    this.comisiones.ListarClientesBroker(request).subscribe(response => {
      this.GroupListaClientes = response.datos.result.map(r => ({
        nombre: r.nombre_completo,
        codigo: r.codigo
      }));
    });
  }

  GroupConfigurarFiltroCliente(): void {
    this.group.get('cliente').valueChanges.pipe(
      debounceTime(300) // Añade debounce para evitar demasiadas solicitudes
    ).subscribe(value => {
      this.GroupClientesFiltrados = this.GroupFiltrarClientes(value);
    });
  }

  GroupFiltrarClientes(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.GroupListaClientes.filter(option =>
      option.nombre.toLowerCase().includes(filterValue)
    );
  }

  GroupClienteSeleccionado(event: MatAutocompleteSelectedEvent): void {
    const selectedOption = this.GroupListaClientes.find(option =>
      option.nombre.toLowerCase() === event.option.value.toLowerCase()
    );
    if (selectedOption) {
      this.GroupCodigos['cliente'] = selectedOption.codigo;
    }
  }

  GroupListaPuertosOrigen: any[] = []
  GroupPuertoOrigen(): void {
    const request = <puertoRequest>{
      pchrCONS_CodVia: '001',
      pchrCONS_TabVia: 'VIA',
      pchrPUER_CodEstandar: '',
      pintPUER_Codigo: '',
      pvchPUER_Nombre: ''
    };

    this.group.get('pod').valueChanges.pipe(
      debounceTime(300), // Añade debounce para evitar demasiadas solicitudes
      switchMap(value => this.proforma.listarPuerto({ ...request, pvchPUER_Nombre: value }))
    ).subscribe(response => {
      this.GroupListaPuertosOrigen = response.datos.result.map(r => ({
        nombre: r.pueR_Nombre,
        codigo: r.pueR_Codigo
      }));
    });
  }

  GroupOrigenSeleccionado(event: MatAutocompleteSelectedEvent) {
    const selectedOption = this.GroupListaPuertosOrigen.find(option => option.nombre.toLowerCase() === event.option.value.toLowerCase());
    if (selectedOption) {
      this.GroupCodigos['pod'] = selectedOption.codigo
    }
  }

  GroupListaPuertosDestino: any[] = []
  GroupPuertoDestino() {
    const request = <puertoRequest>{
      pchrCONS_CodVia: '001',
      pchrCONS_TabVia: 'VIA',
      pchrPUER_CodEstandar: '',
      pintPUER_Codigo: '',
      pvchPUER_Nombre: ''
    };

    this.group.get('pol').valueChanges.pipe(
      debounceTime(300), // Añade debounce para evitar demasiadas solicitudes
      switchMap(value => this.proforma.listarPuerto({ ...request, pvchPUER_Nombre: value }))
    ).subscribe(response => {
      this.GroupListaPuertosDestino = response.datos.result.map(r => ({
        nombre: r.pueR_Nombre,
        codigo: r.pueR_Codigo
      }));
    });
  }

  GroupDestinoSeleccionado(event: MatAutocompleteSelectedEvent) {
    const selectedOption = this.GroupListaPuertosDestino.find(option => option.nombre.toLowerCase() === event.option.value.toLowerCase());
    if (selectedOption) {
      this.GroupCodigos['pol'] = selectedOption.codigo
    }
  }

  ListaEjecutivosGroup2: any[] = []
  listadoejecutivo: listaejecutivos[]
  requestEjecutivo: requestejecutivo
  listarejecutivo() {
    this.requestEjecutivo = <requestejecutivo>{}
    this.requestEjecutivo.entc_Codigo = 3

    this.proforma.listarejecutivo(this.requestEjecutivo).subscribe((response) => {
      if (response.datos.status === 200) {
        this.listadoejecutivo = response.datos.result;

        // Limpiar y reiniciar la lista

        // this.ListaEjecutivosGroup2 = [];

        // Agregar el item 'TODOS'
        const items = { codigo: '', nombre: 'TODOS' }
        this.toppingList.push(items);
        this.ListaEjecutivosGroup2.push(items);

        // Mapear y agregar ejecutivos a ListaEjecutivosGroup2 usando 'items'
        response.datos.result.forEach(r => {
          const items = { codigo: r.codejecutivo, nombre: r.nombreejecutivo }
          this.toppingList.push(items);
          this.ListaEjecutivosGroup2.push(items);
        });

        // Ordenar ListaEjecutivosGroup2 alfabéticamente por nombre
        this.ListaEjecutivosGroup2.sort((a, b) => a.nombre.localeCompare(b.nombre));
        this.toppingList.sort((a, b) => a.nombre.localeCompare(b.nombre));
      }
      this.FilterEjecutivosGroup2 = this.ListaEjecutivosGroup2;
    });
  }


  FilterEjecutivosGroup2 = this.ListaEjecutivosGroup2
  applyFilters2(event: Event, tipo: string) {


    if (tipo == 'ejecutivo') {
      const inputElement = event.target as HTMLInputElement;
      const value = inputElement.value;
      const filtro = value.trim().toLowerCase();
      this.FilterEjecutivosGroup2 = this.ListaEjecutivosGroup2.filter(user => user.nombre.toLowerCase().includes(filtro));
    }

  }

  dataReporteSeguimiento: any[] = []
  ListaBooking: any[] = []
  ListaOvs: any[] = []
  ListaNaves: any[] = []
  ListaClientes: any[] = []
  ListaServices: any[] = []
  ListaPodGroup: any[] = []
  ListaPolGroup: any[] = []
  ListaEtdGroup: any[] = []
  ListaLinea: any[] = []
  GenerarReporteSeguimiento() {

    this.ListaBooking = []
    this.ListaOvs = []
    this.ListaNaves = []
    this.ListaClientes = []
    this.ListaServices = []
    this.ListaEtdGroup = []
    this.ListaLinea = []
    const values = this.group.value

    this.dataReporteSeguimiento = []

    const Ejecutivos: FiltrosMultiSelect[] = []
    const Bookings: FiltrosMultiSelect[] = []
    const Ovs: FiltrosMultiSelect[] = []
    const Naves: FiltrosMultiSelect[] = []
    const Clientes: FiltrosMultiSelect[] = []
    const Services: FiltrosMultiSelect[] = []
    const Pods: FiltrosMultiSelect[] = []
    const Pols: FiltrosMultiSelect[] = []
    const Etds: FiltrosMultiSelect[] = []

    const linea: FiltrosMultiSelect[] = []


    values.ejecutivos.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = r
      items.filt_codigovar = ''
      items.filt_nombre = ''
      Ejecutivos.push(items)
    })

    values.bkg.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = r
      Bookings.push(items)
    })

    values.ov.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = r
      Ovs.push(items)
    })


    values.linea.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = r
      linea.push(items)
    })


    values.nave.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = r
      Naves.push(items)
    })

    values.cliente.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = r
      Clientes.push(items)
    })

    values.service.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = r
      Services.push(items)
    })

    values.pol.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = r
      Pols.push(items)
    })

    values.pod.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = r
      Pods.push(items)
    })

    function convertirFecha(fecha: string): string {
      // Dividir la fecha en día, mes y año
      const partes = fecha.split('/');

      // Obtener día, mes y año del arreglo partes
      const dia = partes[0];
      const mes = partes[1];
      const anio = partes[2];

      // Formatear la fecha en formato yyyy-mm-dd
      const fechaFormateada = `${anio}-${mes}-${dia}`;

      return fechaFormateada;
    }

    values.etd.map(r => {
      const items = <FiltrosMultiSelect>{}
      items.filt_codigoint = 0
      items.filt_codigovar = ''
      items.filt_nombre = convertirFecha(r)
      Etds.push(items)
    })

    const request = <ReporteVentasIRequest>{}
    request.ejecutivo = Ejecutivos//values.ejecutivos.map(dato => `${dato}`).join(', ') || ''
    request.mes = 0
    request.cliente = Clientes //this.GroupCodigos['cliente'] || 0
    request.pol = Pols // this.GroupCodigos['pol'] || 0
    request.etd = Etds
    request.linea = linea //this.GroupCodigos['linea'] || 0
    request.bkg = Bookings //values.bkg || ''
    request.servcontract = Services //values.service || ''
    request.ov = Ovs//values.ov || ''
    request.nave = Naves//values.nave || ''
    request.pod = Pods//this.GroupCodigos['pod'] || 0
    request.tipo = '001'
    request.desde = values.desde
    request.hasta = values.hasta
    this.FilterEjecutivosGroup = []

    this.reportes.ListaReporteVentasI(request).subscribe(response => {

      const datos = response.datos.result.slice()

      const ejecutivosNoEnLista = [];
      const codigosProcesados = [];
      for (const dato of datos) {
        if (dato.entC_CodEjecutivo && !codigosProcesados.includes(dato.entC_CodEjecutivo)) {
          codigosProcesados.push(dato.entC_CodEjecutivo);
          ejecutivosNoEnLista.push(dato);
        }
      }
      console.log(ejecutivosNoEnLista);
      this.FilterEjecutivosGroup2 = this.FilterEjecutivosGroup2.filter(e => e.nombre !== "TODOS");
      for (const ejecutivo of ejecutivosNoEnLista) {
        if (ejecutivo.entC_CodEjecutivo != null) {
          const existeEnEjecutivos = this.FilterEjecutivosGroup2.some(e => e.codigo === ejecutivo.entC_CodEjecutivo);
          if (!existeEnEjecutivos) {
            const items = { codigo: ejecutivo.entC_CodEjecutivo, nombre: ejecutivo.entC_NomCompleto }
            this.FilterEjecutivosGroup2.push(items);
          }
        }
      }
      this.FilterEjecutivosGroup2.push({
        codigo: '',
        nombre: 'TODOS'
      });
      this.FilterEjecutivosGroup = this.FilterEjecutivosGroup2
      this.toppingList = this.FilterEjecutivosGroup2
      console.log(this.FilterEjecutivosGroup);

      this.dataReporteSeguimiento = datos.map(r => {
        const clienteCortado = r.cliente.substring(0, 40);
        return {
          ...r,
          fecha: this.util.formatearfecha(r.fecha, 'dd/mm/yyyy'),
          etd: this.util.formatearfecha(r.etd, 'dd/mm/yyyy'),
          clienteCortado // Agregar clienteCortado al objeto resultante
        };
      });
      console.log(this.dataReporteSeguimiento)

      response.datos.result.forEach(r => {
        if (r.bkg != '' && r.bkg != null) {
          const items = { nombre: r.bkg }
          this.ListaBooking.push(items)
          this.ListaBooking.sort((a, b) => a.nombre.localeCompare(b.nombre));

        }

        if (r.ov != '' && r.ov != null) {
          const items = { nombre: r.ov }
          this.ListaOvs.push(items)
        }

        if (r.linea != '' && r.linea != null) {

          const existe = this.ListaLinea.some(item => item.nombre === r.linea);
          if (!existe) {
            const items = { nombre: r.linea }
            this.ListaLinea.push(items)
            this.ListaLinea.sort((a, b) => a.nombre.localeCompare(b.nombre));
          }
        }

        if (r.nave != '' && r.nave != null) {
          const existe = this.ListaNaves.some(item => item.nombre === r.nave);

          if (!existe) {
            const items = { nombre: r.nave };
            this.ListaNaves.push(items);
            this.ListaNaves.sort((a, b) => a.nombre.localeCompare(b.nombre));
          }
        }

        if (r.cliente != '' && r.cliente != null) {
          const existe = this.ListaClientes.some(item => item.nombre === r.cliente);

          if (!existe) {
            const items = { nombre: r.cliente };
            this.ListaClientes.push(items);
            this.ListaClientes.sort((a, b) => a.nombre.localeCompare(b.nombre));
          }
        }

        if (r.servcontract != '' && r.servcontract != null) {
          const existe = this.ListaServices.some(item => item.nombre === r.servcontract);

          if (!existe) {
            const items = { nombre: r.servcontract };
            this.ListaServices.push(items);
            this.ListaServices.sort((a, b) => a.nombre.localeCompare(b.nombre));
          }
        }

        if (r.pod != '' && r.pod != null) {
          const existe = this.ListaPodGroup.some(item => item.nombre === r.pod);

          if (!existe) {
            const items = { nombre: r.pod };
            this.ListaPodGroup.push(items);
            this.ListaPodGroup.sort((a, b) => a.nombre.localeCompare(b.nombre));

          }
        }

        if (r.pol != '' && r.pol != null) {
          const existe = this.ListaPolGroup.some(item => item.nombre === r.pol);

          if (!existe) {
            const items = { nombre: r.pol };
            this.ListaPolGroup.push(items);
            this.ListaPolGroup.sort((a, b) => a.nombre.localeCompare(b.nombre));

          }
        }

        if (r.etd != '' && r.etd != null) {
          const existe = this.ListaEtdGroup.some(item => item.nombre === this.util.formatearfecha(r.etd, 'dd/mm/yyyy'));

          if (!existe) {
            const items = { nombre: this.util.formatearfecha(r.etd, 'dd/mm/yyyy') };
            this.ListaEtdGroup.push(items);
            this.ListaEtdGroup.sort((a, b) => a.nombre.localeCompare(b.nombre));

          }
        }
      })

      this.filteredUsers = this.ListaBooking
      this.FilterServicesGroup = this.ListaServices
      this.FilterOvsGroup = this.ListaOvs
      this.FilterLineaGroup = this.ListaLinea
      this.FilterClientesGroup = this.ListaClientes
      this.FilterNavesGroup = this.ListaNaves
      this.FilterEjecutivosGroup = this.toppingList
      this.FilterPodGroup = this.ListaPodGroup
      this.FilterPolGroup = this.ListaPolGroup
      this.FilterEtdGroup = this.ListaEtdGroup
    }, (errorServicio) => {
      this.util.ShowMessage({ mensaje: errorServicio.error.meta.mensaje, tipo: 'warning' })
    })

  }

  filterValue = '';
  filteredUsers = this.ListaBooking
  applyFilter(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
    this.filterValue = value.trim().toLowerCase();
    this.filteredUsers = this.ListaBooking.filter(user => user.nombre.toLowerCase().includes(this.filterValue));
  }

  FilterServicesGroup = this.ListaServices
  FilterOvsGroup = this.ListaOvs
  FilterLineaGroup = this.ListaLinea
  FilterClientesGroup = this.ListaClientes
  FilterNavesGroup = this.ListaNaves
  FilterEjecutivosGroup = this.toppingList
  FilterPodGroup = this.ListaPodGroup
  FilterPolGroup = this.ListaPolGroup
  FilterEtdGroup = this.ListaEtdGroup
  applyFilters(event: Event, tipo: string) {
    if (tipo == 'service') {
      const inputElement = event.target as HTMLInputElement;
      const value = inputElement.value;
      this.filterValue = value.trim().toLowerCase();
      this.FilterServicesGroup = this.ListaServices.filter(user => user.nombre.toLowerCase().includes(this.filterValue));
    }

    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;

    switch (tipo) {
      case 'ov':
        // const inputElement = event.target as HTMLInputElement;
        // const value = inputElement.value;
        this.filterValue = value.trim().toLowerCase();
        this.FilterOvsGroup = this.ListaOvs.filter(user => user.nombre.toLowerCase().includes(this.filterValue));
        break;
      case 'cliente':
        this.filterValue = value.trim().toLowerCase();
        this.FilterClientesGroup = this.ListaClientes.filter(user => user.nombre.toLowerCase().includes(this.filterValue));
        break;
      case 'nave':
        this.filterValue = value.trim().toLowerCase();
        this.FilterNavesGroup = this.ListaNaves.filter(user => user.nombre.toLowerCase().includes(this.filterValue));
        break;
      case 'ejecutivo':
        this.filterValue = value.trim().toLowerCase();
        this.FilterEjecutivosGroup = this.toppingList.filter(user => user.nombre.toLowerCase().includes(this.filterValue));
        //this.FilterEjecutivosGroup.sort((a, b) => a.nombre.localeCompare(b.nombre));
        break;
      case 'pod':
        this.filterValue = value.trim().toLowerCase();
        this.FilterPodGroup = this.ListaPodGroup.filter(user => user.nombre.toLowerCase().includes(this.filterValue));
        break;
      case 'pol':
        this.filterValue = value.trim().toLowerCase();
        this.FilterPolGroup = this.ListaPolGroup.filter(user => user.nombre.toLowerCase().includes(this.filterValue));
        //this.FilterPolGroup.sort((a, b) => a.nombre.localeCompare(b.nombre));
        break;
      case 'etd':
        this.filterValue = value.trim().toLowerCase();
        this.FilterEtdGroup = this.ListaEtdGroup.filter(user => user.nombre.toLowerCase().includes(this.filterValue));
        break;
      case 'linea':
        this.filterValue = value.trim().toLowerCase();
        this.FilterLineaGroup = this.ListaLinea.filter(user => user.nombre.toLowerCase().includes(this.filterValue));
        break;
      default:
        break;
    }

  }

  LimpiarFiltros() {
    this.group.reset({
      desde: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      hasta: new Date(),
      //ejecutivo: null,
      cliente: [],
      pod: [],
      pol: [],
      etd: [],
      bkg: [],
      ov: [],
      service: [],
      nave: [],
      ejecutivos: []
    });
  }


  exportReportTrack() {
    console.log(this.dataReporteSeguimiento)
    const datos = <DataExportExcel>{}
    let nuevadata = []

    //ARREGLAR LA DATA SI ES NECESARIO - CAMBIA LAS CABECERAS Y MUESTRA SOLO LOS DATOS NECESARIOS
    this.dataReporteSeguimiento.forEach(row => {

      const { fecha, ov, ejecutivo, cliente, linea, servcontract, nave, etd, bkg, pol, pod, st20, st40, hc40, nr40, teu } = row;
      const newItem = {
        "DATE": fecha,
        "OV": ov,
        "EJECUTIVO": ejecutivo,
        "CLIENTE": cliente,
        "LINEA": linea,
        "SERVICE CONTRACT": servcontract || '',
        "NOMBRE NAVE": nave || '',
        "ETD": etd,

        "BKG": bkg || '',
        "POL": pol || '',
        "POD": pod || '',
        "20ST": st20 || 0,
        "40ST": st40 || 0,
        "40HC": hc40 || 0,
        "40NR": nr40 || 0,
        "TEU": teu || 0,
      };

      nuevadata.push(newItem);

    });

    console.log(nuevadata)

    const data = [
      { data: nuevadata, cabeceras: ['ITEM', 'PRODUCTOS', 'PRECIO'] }
    ]
    this.util.ExportarExcel(data, 'reporte acos.xlsx')
  }

}
